import { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [meta, setMeta] = useState({ branches: [], categories: [], vendors: [], order_statuses: [], payment_statuses: [] });
  const [branch, setBranch] = useState("All");
  const [aiOpen, setAiOpen] = useState(false);
  const [aiInitialQuery, setAiInitialQuery] = useState("");

  const loadMeta = async () => {
    try { const res = await api.get("/meta"); setMeta(res.data); } catch {}
  };
  useEffect(() => { loadMeta(); }, []);

  const openAI = (q = "") => { setAiInitialQuery(q); setAiOpen(true); };

  return (
    <AppContext.Provider value={{ meta, loadMeta, branch, setBranch, aiOpen, setAiOpen, openAI, aiInitialQuery }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
